import React from "react";
import autoBind from "react-autobind";
import {Redirect} from "react-router-dom";
import Field from "../../../components/Field";
import noty from "../../../lib/noty";
// import FieldLocation from '../../../components/FieldLocation'
import {pointInstructions} from "../../../strings/en-us/text";
import {InstructionsContainer} from "../../../components/Instructions";
import {PanelContainer, Panel} from "../../../components/Panel";
import {MapPortal} from "../../../components/Map";
import MapEditPoint from "../MapEditPoint";
import HelpText from "../../../components/HelpText";

export default class NewBuilding extends React.Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.state = {
      panelOpen: true,
      fetching: false,
      touched: false,
      redirect: null,
      building: this.props.building
    };
  }

  handlePanelToggle() {
    this.setState({panelOpen: !this.state.panelOpen});
  }

  handleChange({name, value}) {
    const path = name.split(".");
    this.setState({
      touched: true,
      building: this.state.building.setIn(path, value)
    });
  }

  handleSubmit(event) {
    event.preventDefault();
    const {building} = this.state;
    this.setState({fetching: true});
    building
      .create()
      .then(created => {
        this.setState({redirect: `${this.props.match.url}/${created._id}`});
        noty.success("Building created.");
      })
      .catch(err => {
        this.setState({fetching: false});
        noty.errors(err);
      });
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    const {building, fetching, touched} = this.state;
    return (
      <div>
        <PanelContainer width={475} open={this.state.panelOpen} onToggle={this.handlePanelToggle}>
          <Panel
            checkCanAdd="buildings"
            onSaveClick={this.handleSubmit}
            saveTitle="Create New Building"
            fetching={fetching}
            touched={touched}
            touchedMessage="Are you sure that you want to leave? This marker has unsaved changes.">
            <div>
              <div className="row">
                <div className="col-xs-12">
                  <Field
                    name="name"
                    value={building.name}
                    onChange={this.handleChange}
                    label="Building Name"
                    disabled={fetching}
                  />
                </div>
              </div>
              {/* <div className='row'>
                <div className='col-xs-12'>
                  <FieldLocation
                    addressName='address'
                    geoName='geo.coordinates'
                    value={building.address}
                    onChange={this.handleChange}
                    label='Building Location'
                    disabled={fetching}
                />
                </div>
              </div> */}
              <InstructionsContainer>{pointInstructions}</InstructionsContainer>
              <HelpText
                href="https://mapplug.zendesk.com/hc/en-us/articles/360006403993-Adding-an-additional-building"
                description="Need help? See our guide on adding a building."
              />
            </div>
          </Panel>
        </PanelContainer>
        <MapPortal center={building.geo.coordinates}>
          <MapEditPoint
            center={building.geo.coordinates}
            onMarkerLocationChange={coords =>
              this.handleChange({
                name: "geo.coordinates",
                value: coords
              })
            }
          />
        </MapPortal>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Facility/NewBuilding/index.jsx